import PointSizeMap from "./PointSizeMap";
export default class ConstantPointSizeMap extends PointSizeMap {
  constructor(pointSize) {
    super();
    this.pointSize = pointSize;
  }
  mapValueToPointSize(_value) {
    return this.pointSize;
  }
}